import "swiper/css";
import "swiper/css/autoplay";
import 'swiper/css/navigation';


import { PortableText } from '@portabletext/react';
import { useImages } from '../general/ImageProvider';
import { urlFor } from '../lib/imageUrl';

import { Autoplay, Navigation } from 'swiper/modules';

import { Swiper, SwiperSlide } from "swiper/react";


import { Link } from "react-router-dom";

// import gizmoImg from '';


function HomeSlides() {
    const images = useImages();

    if (!Array.isArray(images) || !images.length) {
        return <div></div>;
    }

    // Helper function to find an image by title
    const getImageByTitle = (title) => {
        return images.find((image) => image.title === title);
    };

    // Fetch specific images by their titles

    const slideone = getImageByTitle('Text Gizmo');
    const slidetwo = getImageByTitle('Image Gizmo');
    const slidethree = getImageByTitle('PDF Gizmo');





    return (

        <div className="d-mobile">
            <Swiper
                breakpoints={{


                    520: {
                        // Mobile: 500px and up
                        slidesPerView: 1.5,
                    },

                    1400: {
                        // Mobile: 768px and up
                        slidesPerView: 3,
                    },

                 

                    800: {
                        slidesPerView: 2.5,
                    },


                }}
                spaceBetween={20}
                loop={true}
                modules={[Autoplay, Navigation]}
                navigation={{
                    prevEl: '.custom-prev',
                    nextEl: '.custom-next',
                }}
                autoplay={{ delay: 4000, disableOnInteraction: false }}
                className="mySwiper"
            >


                <SwiperSlide className="home-slide px-1 py-3" >   <Link to="/text-gizmo" >
                    <div className="gizmo-card ">
                        <div className="gizmo-img">
                            {slideone && (

                                <img
                                    src={urlFor(slideone.file.asset)}
                                    alt={slideone.altText || 'Sanity Image'}
                                 className="img-fluid" />

                            )}
                        </div>
                        <div className="gizmo-details-well">
                            <div className="gizmo-title">
                                {slideone.sectionTitle}
                            </div>
                            <div className="gizmo-desc">
                                {slideone.content && (
                                    <PortableText
                                        value={slideone.content}
                                        components={{
                                            block: {
                                                normal: ({ children }) => <p>{children}</p>,
                                                h1: ({ children }) => <h1>{children}</h1>,
                                                h2: ({ children }) => <h2>{children}</h2>,
                                            },
                                            marks: {
                                                link: ({ children, value }) => (
                                                    <a
                                                        href={value.href}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="text-blue-500"
                                                    >
                                                        {children}
                                                    </a>
                                                ),
                                            },
                                        }}
                                    />
                                )}
                            </div>
                            <Link to="/text -gizmo" className="gizmo-card-link">
                                {/* {slideone.btnlabel} */}
                            </Link>
                        </div>
                    </div>
                </Link></SwiperSlide>
             
                <SwiperSlide className="home-slide px-1 py-3" >   <Link to="/image-gizmo" >
                    <div className="gizmo-card ">
                        <div className="gizmo-img">
                            {slidetwo && (

                                <img
                                    src={urlFor(slidetwo.file.asset)}
                                    alt={slidetwo.altText } className="img-fluid"
                                />

                            )}
                        </div>
                        <div className="gizmo-details-well">
                            <div className="gizmo-title">
                                {slidetwo.sectionTitle}
                            </div>
                            <div className="gizmo-desc">
                                {slidetwo.content && (
                                    <PortableText
                                        value={slidetwo.content}
                                        components={{
                                            block: {
                                                normal: ({ children }) => <p>{children}</p>,
                                                h1: ({ children }) => <h1>{children}</h1>,
                                                h2: ({ children }) => <h2>{children}</h2>,
                                            },
                                            marks: {
                                                link: ({ children, value }) => (
                                                    <a
                                                        href={value.href}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="text-blue-500"
                                                    >
                                                        {children}
                                                    </a>
                                                ),
                                            },
                                        }}
                                    />
                                )}
                            </div>
                            <Link to="/text -gizmo" className="gizmo-card-link">
                                {/* {slideone.btnlabel} */}
                            </Link>
                        </div>
                    </div>
                </Link></SwiperSlide>
             
                <SwiperSlide className="home-slide px-1 py-3" >   <Link to="/pdf-gizmo" >
                    <div className="gizmo-card ">
                        <div className="gizmo-img">
                            {slidethree && (

                                <img
                                    src={urlFor(slidethree.file.asset)}
                                    alt={slidethree.altText } className="img-fluid"
                                />

                            )}
                        </div>
                        <div className="gizmo-details-well">
                            <div className="gizmo-title">
                                {slidethree.sectionTitle}
                            </div>
                            <div className="gizmo-desc">
                                {slidethree.content && (
                                    <PortableText
                                        value={slidethree.content}
                                        components={{
                                            block: {
                                                normal: ({ children }) => <p>{children}</p>,
                                                h1: ({ children }) => <h1>{children}</h1>,
                                                h2: ({ children }) => <h2>{children}</h2>,
                                            },
                                            marks: {
                                                link: ({ children, value }) => (
                                                    <a
                                                        href={value.href}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="text-blue-500"
                                                    >
                                                        {children}
                                                    </a>
                                                ),
                                            },
                                        }}
                                    />
                                )}
                            </div>
                            <Link to="/text -gizmo" className="gizmo-card-link">
                                {/* {slideone.btnlabel} */}
                            </Link>
                        </div>
                    </div>
                </Link></SwiperSlide>
             



            </Swiper>
            <div className="home-slide">
            <div className="arrow-grp">
                <div className="swiper-button-prev custom-prev"></div>
                <div className="swiper-button-next custom-next"></div>
            </div>
            </div>
        </div>

    );
};
export default HomeSlides;